




var search =window.location.search;
/*if(search){
window.location.href = "http://ydgx.softtone.cn"+search;
}*/

import Vue from 'vue'
import App from './App'
import router from './router/index.js'

import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
import hls from "videojs-contrib-hls";
Vue.use(VideoPlayer)
Vue.use(hls);

import VueResource from 'vue-resource';
Vue.use(VueResource);


import Icon from 'vue-svg-icon/Icon.vue'
Vue.component('icon', Icon)



import api from '../static/api/api1.js'

import global_ from './components/tool/Global'
Vue.prototype.GLOBAL = global_



import tyh from '../static/api/api2.js'



Vue.prototype.$api = api
Vue.config.productionTip = false


Vue.prototype.$tyh = tyh
Vue.config.productionTip = false


import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'

Vue.use(ConfirmPlugin)


import LoadingPlugin from 'vux/src/plugins/loading/index.js'

Vue.use(LoadingPlugin)


new Vue({
el: '#app',
router,
components: { App },
template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js